import { getAuth } from 'firebase/auth';
import app from './firebaseInitializers';

export default async function getAuthToken(): Promise<string> {
  const firebaseApp = app();
  if (!firebaseApp) {
    throw new Error('Firebase app not initialized');
  }

  const firebaseAuth = getAuth(firebaseApp);

  const user = firebaseAuth.currentUser;
  if (!user) {
    throw new Error('Not signed in');
  }
  return user.getIdToken();
}
